<script>
import RecycleModal from './RecycleModal.vue'
import FailModal from './FailModal.vue'
import PassModal from './PassModal.vue'
import Accordion from '../../Accordion.vue'
import AccordionItem from '../../AccordionItem.vue'
import LoadingCvPersonalDetails from '../Applicant/LoadingCV/PersonalDetails.vue'
import LoadingCvAims from '../Applicant/LoadingCV/Aims.vue'
import StarRating from 'vue-star-rating'
import Cv from './LoadingCV/Cv.vue'
import moment from 'moment'
import BackgroundVerificationCheckModal from './BackgroundVerificationCheckModal.vue'
import ModalConfirm from '../../ModalConfirm.vue'
import ComponentStarRating from '../../ComponentStarRating.vue'
import MoveToLoadingOfferModal from './MoveToLoadingOffer.vue';

export default {
    components: {
        RecycleModal,
        FailModal,
        PassModal,
        Accordion,
        AccordionItem,
        LoadingCvPersonalDetails,
        LoadingCvAims,
        StarRating,
        Cv,
        BackgroundVerificationCheckModal,
        ModalConfirm,
        ComponentStarRating,
        MoveToLoadingOfferModal
    },

    props: {
        jobApplication: {
            type: Object|Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        module: {
            type: Object|Array,
            required: true
        },
        traitStatementsByCluster: {
            type: Object|Array,
            required: true
        },
        interviewAnswers: {
            type: Object|Array,
            required: true
        },
        interviewScores: {
            type: Object|Array,
            required: true
        },
        logs: {
            type: Object|Array,
            required: false
        },
    },

    data() {
        return {
            average: 0,
            rating: [],
            fail_reason: '',
            passBtnDisabled: false,
            panel_interview_status: this.jobApplication.panel_interview_status,
            is_background_check_manual: false,
            lastSavedAnswers: {},
            lastSavedScores: {}
        }
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        changeRatingValue(key, value) {
            this.rating[key] = parseInt(value);
        },
        fail(fail_reason) {
            this.panel_interview_status = 'failed';
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        backgroundCheck(value) {
            this.is_background_check_manual = value.manual_pass;
        },
        pass(value) {
            this.panel_interview_status = 'passed';
            this.$nextTick(() => {
                this.$refs.passedButton.click();
            });
        },
        submitBackgroundVerification() {
            this.$nextTick(() => {
                this.$refs.submitBackgroundVerificationButton.click();
            });
        },
        convertDate(date, format = 'YYYY-MM-DDThh:mm') {
            return moment.parseZone(date).format(format)
        },
        setRating: function(rating){
            this.rating = parseInt(rating);
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.panel_interview_status = 'passed';
        },
        passSendToSage() {
            this.panel_interview_status = 'passed';
            this.send_to_sage = 'yes';

            let btn = this.$refs['passButton'];
            setTimeout(function() {
                btn.click();
            }, 200);
        },
        passOnly() {
            this.panel_interview_status = 'passed';
            this.send_to_sage = '';

            let btn = this.$refs['passButton'];
            setTimeout(function() {
                btn.click();
            }, 200);
        },
        saveInterviewAnswers(updatedAnswers, showFlash = false) {
            // Check if there are changes in the answers before making the save request
            if (Object.keys(updatedAnswers).length === 0 || JSON.stringify(updatedAnswers) === JSON.stringify(this.lastSavedAnswers)) {
                console.log("No changes detected, no need to save.");
                return;
            }

            // For example, perform an Axios request to save the updated answers
            axios.post('/recruiter/active-requisitions/save-interview-answers', {
                answers: updatedAnswers,
                job_application_id: this.jobApplication.id,
            });

            if (showFlash) {
                this.showFlashMessages('Interview answers saved successfully.', 'success');
            }
        },
        saveInterviewAnswersManual() {
            let updatedAnswers = {};
            let radioGroups = {};
            document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]')
                .forEach(input => {
                    const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                    if (nameParts) {
                        const index = nameParts[1];
                        if (!radioGroups[index]) radioGroups[index] = [];
                        if (input.type === 'radio') {
                            radioGroups[index].push(input);
                        }
                    }
                });

            document.querySelectorAll('[name^="interview_answers\\["][name$="\\[answer\\]"]').forEach(input => {
                const nameParts = input.name.match(/^interview_answers\[(\d+)\]\[answer\]$/);
                if (nameParts) {
                    const index = nameParts[1];
                    const jobApplicationId = document.querySelector(`[name="interview_answers[${index}][job_application_id]"]`).value;
                    const interviewQuestionId = document.querySelector(`[name="interview_answers[${index}][interview_question_id]"]`).value;
                    let answer = '';

                    if (input.type === 'radio') {
                        if (radioGroups[index] && radioGroups[index][0] === input) {
                            const checkedRadio = radioGroups[index].find(r => r.checked);
                            answer = checkedRadio ? checkedRadio.value : '';
                        } else {
                            return; // skip, already processed
                        }
                    } else {
                        answer = input.value;
                    }

                    if (jobApplicationId && interviewQuestionId !== undefined) {
                        updatedAnswers[index] = {
                            job_application_id: jobApplicationId,
                            interview_question_id: interviewQuestionId,
                            answer: answer
                        };
                    }
                }
            });

            this.saveInterviewScores();
            this.saveInterviewAnswers(updatedAnswers, true);
            this.lastSavedAnswers = updatedAnswers;
        },
        saveInterviewScores() {
            let interviewScores = {
                id: this.interviewScores['Panel Interview'] ? this.interviewScores['Panel Interview']['id'] : null,
                phase: 'Panel Interview',
            };

            const panelInterview = document.querySelector('.panel-interview');
            if (panelInterview) {
                panelInterview.querySelectorAll('[name^="interview_scores\\[0\\]\\["][name$="\\]"]').forEach(input => {
                    const nameParts = input.name.match(/^interview_scores\[0\]\[(.+)\]$/);
                    if (nameParts) {
                        const key = nameParts[1];
                        interviewScores[key] = input.value;
                    }
                });
            }

            if (Object.keys(interviewScores).length === 0 || JSON.stringify(interviewScores) === JSON.stringify(this.lastSavedScores)) {
                console.log("No changes detected, no need to save.");
                return;
            }

            axios.post('/recruiter/active-requisitions/save-interview-answers', {
                interview_scores: interviewScores,
                job_application_id: this.jobApplication.id,
            });

            this.lastSavedScores = interviewScores; // Update stored scores
        },
        startAutoSaveScores() {
            this._autoSaveScoresInterval = setInterval(() => {
                this.saveInterviewScores();
            }, 3000);
        },
        showFlashMessages(message = 'Oops, something went wrong.', type = 'warning') {
            let $flash = $(`
                <div id="flash-message-container"  data-component="flashMessages" onclick="this.classList.add('hide')">
                    <div class="${type} callout block"><div class="message">${message} <i class="fas fa-times pointer"></i></div></div>
                </div>
            `);
            $('body').append($flash);
        }
    },
    mounted() {
        if (this.jobApplication.showBackgroundVerificationWarning) {
            this.toggleModal('backgroundVerificationCheckModal')
        }

        if (this.jobApplication.panel_interview_status == 'passed') {
            this.passBtnDisabled = true;
        }

        this.startAutoSaveScores();
    },
    beforeUnmount() {
        // Stop the auto save scores interval when component unmounts
        if (this._autoSaveScoresInterval) clearInterval(this._autoSaveScoresInterval);
    },
    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.panel_interview_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    },
    computed: {
        disabled() {
            return ( this.jobApplication.skill_assessment_status === null || this.jobApplication.skill_assessment_status === '') ? true : false
        },
        matricCertNumber() {
            if (this.jobApplication.user.user_detail === null) {
                return null;
            }

            const qualification = this.jobApplication.user.user_detail.qualifications.find(function (data) {
                return data.highest_edu_level == 1;
            });

            if (qualification) {
                return qualification.qualification_documents.length > 0;
            }

            return null
        },
        iFactsMatricCheck() {
            if (!this.jobApplication.job.requisition.person_specification.background_verification_specs) {
                return null;
            }

            return this.jobApplication.job.requisition.person_specification.background_verification_specs.filter(function (data) {
                if (!data.ifacts_check) {
                    return null;
                }
                return [55, 56, 57, 132, 6, 7, 98].includes(parseInt(data.ifacts_check.check_id));
            });
        },
        excludedIds() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber &&
                this.jobApplication.background_verification_results.length <= 0
            ) {
                return this.iFactsMatricCheck.map(function (item) {
                    return item.id;
                }).join(',')
            }

            if (
                this.iFactsMatricCheck &&
                this.matricCertNumber &&
                (
                    this.jobApplication.background_verification_results.length !==
                    this.jobApplication.job.requisition.person_specification.background_verification_specs.length
                )
            ) {
                return this.jobApplication.background_verification_results.map(function (item) {
                    return item.background_verification_spec_id
                })
                    .join(',')
            }
        },
        modalMessage() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber &&
                this.jobApplication.background_verification_results.length <= 0
            ) {
                return 'This person you are trying to send to iFacts does not have a Matric Certificate to check.\nAre you sure you want to send all remaining checks?'
            }

            return 'Are you sure? Passing the candidate will fire off iFacts API checks'
        },
    }
}
</script>

<template>
    <div class="panel-interview">
        <div class="grid-x grid-padding-x">
            <div class="cell small-6" style="border-right: solid 1px #D1D1D1; padding: 30px 35px">
                <div style="width:90%">
                    <strong>Invite candidate to a panel interview:</strong>
                    <p>Pick three timeslots that the candidate will be able to pick from</p>
                    <form action="" method="post" class="pt-0 mt-2">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Option 1</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="panel_interview_result[date_first]"
                                required
                                :value="(jobApplication.panel_interview_result) ? convertDate(jobApplication.panel_interview_result.date_first) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 2</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="panel_interview_result[date_second]"
                                required
                                :value="(jobApplication.panel_interview_result) ? convertDate(jobApplication.panel_interview_result.date_second) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 3</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="panel_interview_result[date_third]"
                                required
                                :value="(jobApplication.panel_interview_result) ? convertDate(jobApplication.panel_interview_result.date_third) : convertDate(this.value)"
                            />
                        </div>
                        <input type="hidden" name="panel_interview_invitation"/>
                        <button :disabled="inviteBtnDisabled || disabled" class="button" name="panel_interview_invitation" type="submit">Send Invites</button>
                    </form>
                    <form action="" method="post" class="pt-0 mt-2">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Set date and time manually</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="panel_interview_result[date_first]"
                                required 
                                :value="(jobApplication.panel_interview_result) ? convertDate(jobApplication.panel_interview_result.date_first) : convertDate(this.value)"
                            />
                        </div>
                        <input type="hidden" name="panel_interview_invitation_manually"/>
                        <button :disabled="disabled" class="button mt-2" name="panel_interview_invitation_manually" type="submit">Set time manually</button>
                    </form>
                    <br />
                    <Cv
                        :jobApplication="jobApplication"
                        :module="module"
                        div-class="small-10"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                    />
                </div>
            </div>
            <div class="cell small-6 p-4">
                <form method="post" ref="panelInterviewForm" class="pt-0 mt-2">
                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                    <input type="hidden" name="fail_reason" :value="fail_reason" />
                    <input type="hidden" name="exclude_matric_check" :value="excludedIds"/>
                    <input type="hidden" name="panel_interview_status" :value="panel_interview_status"></input>
                    <input type="hidden" name="send_to_sage" :value="send_to_sage" />

                    <h4>Invitation</h4>
                    <div v-if="jobApplication.panel_interview_result">
                        <strong>Invitation Status:</strong> {{ (jobApplication.panel_interview_result.status === 'reschedule') ? 'The candidate is not available. Please resend a new invitation.' : jobApplication.panel_interview_result.status}}
                        <br>
                        <strong>Date and Time Scheduled: </strong>{{ jobApplication.panel_interview_result.date_selected ?
                        convertDate(jobApplication.panel_interview_result.date_selected, 'MMMM D, YYYY H:mm') : '' }}
                        <br>
                    </div>
                    <div v-else>
                        <strong>Invitation Status:</strong> Not yet sent
                        <br>
                        <strong>Date and Time Scheduled:</strong> Not yet set
                        <br>
                    </div>
                    <strong>Final Status:</strong> {{ jobApplication.panel_interview_status }}
                    
                    <span v-if="logs !== null && logs !== ''">
                        &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created, 'YYYY-MM-DD HH:mm') }})
                    </span>

                    <div class="grid-x grid-padding-x">
                        <div class="cell shrink">
                            <div v-if="this.jobApplication.job.requisition.person_specification.ats_type != 'agent'">
                                <button class="d-none"
                                    value="pass"
                                    ref="passButton"
                                    type="submit"
                                ></button>

                                <button
                                    type="button"
                                    class="button px-5"
                                    :disabled="passBtnDisabled || disabled"
                                    @click="toggleModal('moveToLoadingOfferModal')"
                                >Pass</button>
                            </div>
                            <div v-else>
                                <button class="d-none" ref="passedButton"></button>
                                <button class="button success px-5" type="button" @click="toggleModal((jobApplication.ifact_form && jobApplication.permission_granted) ? 'passModal' : 'backgroundVerificationCheckModal')" :disabled="passBtnDisabled || disabled">
                                    Pass
                                </button>
                            </div>
                        </div>
                        <div>
                            <button :disabled="disabled" class="d-none" value="failed" ref="failedButton" name="panel_interview_status"></button>
                            <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                        </div>
                        <div class="cell shrink">
                            <button :disabled="disabled" class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                        </div>
                    </div>
                    <hr>
                    <h4 class="mt-4">Interview Questions</h4>
                    <div
                        v-for="(interviewQuestion, index) in jobApplication.job.requisition.person_specification.interview_questions" :key="`interview_question_${index}`">
                        <div v-if="interviewQuestion.phase == 'Panel Interview'">
                            <input
                                type="hidden"
                                :name="`interview_answers[${index}][job_application_id]`"
                                :value="jobApplication.id"
                            />
                            <input
                                type="hidden"
                                :name="`interview_answers[${index}][interview_question_id]`"
                                :value="interviewQuestion.id"
                            />

                            <div v-if="interviewAnswers[interviewQuestion.id]">
                                <input
                                    type="hidden"
                                    :name="`interview_answers[${index}][id]`"
                                    :value="interviewAnswers[interviewQuestion.id]['id']"
                                />
                            </div>

                            <div class="d-flex align-items-center gap-1">
                                <p><strong>{{ index + 1 }}. </strong></p> <span v-html="interviewQuestion.title"></span>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'yes_no'" class="d-flex">
                                <div class="d-flex align-items-center yes-no-item">
                                    <input
                                        :disabled="disabled"
                                        type="radio"
                                        value="1"
                                        :name="`interview_answers[${index}][answer]`"
                                        :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 1)"
                                    />

                                    <label>
                                        Yes
                                    </label>
                                </div>

                                <div class="d-flex align-items-center yes-no-item">
                                    <input
                                        :disabled="disabled"
                                        type="radio"
                                        value="0"
                                        :name="`interview_answers[${index}][answer]`"
                                        :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 0)"
                                    />

                                    <label>
                                        No
                                    </label>
                                </div>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'free'">
                                <textarea :disabled="disabled" :name="`interview_answers[${index}][answer]`">{{ interviewAnswers[interviewQuestion.id] ? interviewAnswers[interviewQuestion.id]['answer'] : '' }}</textarea>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'rating'">
                                <component-star-rating
                                    :name="`interview_answers[${index}][answer]`"
                                    :star-size="18"
                                    border-color="#455666"
                                    active-border-color="#455666"
                                    :border-width="3"
                                    rounded-corners
                                    :padding="1"
                                    inactive-color="white"
                                    :default-rating="parseInt(interviewAnswers[interviewQuestion.id] ? interviewAnswers[interviewQuestion.id]['answer'] : 0)"
                                ></component-star-rating>
                            </div>
                            <br>
                        </div>
                    </div>

                    <input type="hidden" name="interview_scores[0][job_application_id]`" :value="jobApplication.id" />
                    <input type="hidden" name="interview_scores[0][phase]`" value="Panel Interview" />
                    <input type="hidden" name="interview_scores[0][id]`" :value="interviewScores['Panel Interview'] ? interviewScores['Panel Interview']['id'] : null" />
                    <div class="form-control">
                        <label>Pitch:</label>
                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pitch]"
                            :value="interviewScores['Panel Interview'] ? interviewScores['Panel Interview']['pitch'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Pace:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pace]"
                            :value="interviewScores['Panel Interview'] ? interviewScores['Panel Interview']['pace'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Tone:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][tone]"
                            :value="interviewScores['Panel Interview'] ? interviewScores['Panel Interview']['tone'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Clarity:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][clarity]"
                            :value="interviewScores['Panel Interview']? interviewScores['Panel Interview']['clarity'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Score:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][score]"
                            :value="interviewScores['Panel Interview'] ? interviewScores['Panel Interview']['score'] : 0"
                        />
                    </div>
                    <div class="form-control">
                        <div class="grid-x grid-padding-x">
                            <div class="cell shrink">
                                <div v-if="this.jobApplication.job.requisition.person_specification.ats_type != 'agent'">
                                    <button class="d-none"
                                        value="pass"
                                        ref="passButton"
                                        type="submit"
                                    ></button>

                                    <button
                                        type="button"
                                        class="button px-5"
                                        :disabled="passBtnDisabled || disabled"
                                        @click="toggleModal('moveToLoadingOfferModal')"
                                    >Pass</button>
                                </div>
                                <div v-else>
                                    <button class="d-none" ref="passedButton"></button>
                                    <button class="button success px-5" type="button" @click="toggleModal((jobApplication.ifact_form && jobApplication.permission_granted) ? 'passModal' : 'backgroundVerificationCheckModal')" :disabled="passBtnDisabled || disabled">
                                        Pass
                                    </button>
                                </div>
                            </div>
                            <div>
                                <button class="d-none" value="failed" ref="failedButton" name="panel_interview_status"></button>
                                <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                            </div>
                            <div class="cell shrink">
                                <button :disabled="disabled" class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                            </div>
                            <div class="cell shrink">
                                <button type="button" @click="saveInterviewAnswersManual()" class="button">Save Interview Answers</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <pass-modal ref="passModal" :job-application="jobApplication" @submit="pass" @backgroundCheck="backgroundCheck" :message="modalMessage"/>
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <background-verification-check-modal ref="backgroundVerificationCheckModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <move-to-loading-offer-modal 
            ref="moveToLoadingOfferModal"
            @passSendToSage="passSendToSage"
            @passOnly="passOnly"
            :enable-send-to-sage="(jobApplication.job.requisition.job_profile.external_requisition_number && jobApplication.job.requisition.job_profile.sage_job_requisition_id && jobApplication.job.requisition.job_profile.external_requisition_number !== '' && jobApplication.job.requisition.job_profile.sage_job_requisition_id !== '') ? true : false"
        />
    </div>
</template>